// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1KBRj","title":"FrontImage_title__29Sgv"};